import CocaCola from "../../../assets/references/cocacola.jpg";
import AlBaraka from "../../../assets/references/alBaraka.jpg";
import Carrefour from "../../../assets/references/Carrefour.jpg";
import Colins from "../../../assets/references/Colins.jpg";
import Garanti from "../../../assets/references/Garanti.jpg";
import Mercedes from "../../../assets/references/Mercedes.jpg";
import Microsoft from "../../../assets/references/Microsoft.jpg";
import Nike from "../../../assets/references/Nike.jpg";
import Apple from "../../../assets/references/apple.jpg";
import BankMellat from "../../../assets/references/bankmellat.jpg";
import EuroLeague from "../../../assets/references/europaLeague.jpg";
import Hanwha from "../../../assets/references/hanwha.jpg";
import InanMakine from "../../../assets/references/inanMakina.jpg";
import ManU from "../../../assets/references/manU.jpg";
import Nvidia from "../../../assets/references/nvidia.jpg";
import Oppo from "../../../assets/references/oppo.jpg";
import RumeliUni from "../../../assets/references/rumeliUni.jpg";
import Shell from "../../../assets/references/shell.jpg";
import Toyota from "../../../assets/references/toyota.jpg";

export const RefImages = [
  CocaCola,
  AlBaraka,
  Apple,
  BankMellat,
  Carrefour,
  Colins,
  EuroLeague,
  Garanti,
  Hanwha,
  InanMakine,
  ManU,
  Mercedes,
  Microsoft,
  Nike,
  Nvidia,
  Oppo,
  RumeliUni,
  Shell,
  Toyota,
];
